<template>
  <div class="rules">
    <div v-for="(item,index) in contacList" :key="index">
       <!-- <h4 class="headtitle">{{item.titleName}}:</h4> -->
       <div v-html="item.award1"></div>
       <!-- <template v-if="item.type==1">
          <div class="boxs">{{item.award1}}名</div>
       </template>
       <template v-else>
        <div class="boxs">
          {{$t('GoldAward')}} {{item.award1}}名<br />
          {{$t('Silveraward')}} {{item.award2}}名<br />
          {{$t('Bronze')}} {{item.award3}}名
        </div>
      </template> -->
    </div>

    <!-- <h4 class="headtitle">{{$t('Completebicycle')}}</h4>
    <div class="boxs">
      {{$t('GoldAward')}}  1名<br/>
      {{$t('Silveraward')}}  3名<br/>
      {{$t('Bronze')}}  5名
    </div>
   

    <h4 class="headtitle">{{$t('Electricbicycle')}}</h4>
    <div class="boxs">
      金奖 1名<br/> 
      银奖 3名<br/> 
      铜奖 5名
    </div>

    <h4 class="headtitle">{{$t('BicycleElectricbicycleparts')}}</h4>
    <div class="boxs">
      金奖  1名<br/>
      银奖  3名<br/>
      铜奖  5名
    </div> -->

  </div>
</template>

<script>
export default {
  data() {
    return {
      contacList: [],
    };
  },
  created() {
    this.$getHttp("pc/tAwardSetting/findAllAwardSetting", {}).then((res) => {
      if (res.success) {
        // award1: 1
        // award2: 0
        // award3: 0
        // award4: 0
        // createBy: ""
        // createDate: 1662630615000
        // deleteFlag: "0"
        // id: 1
        // language: "1"
        // titleName: "组委会大奖"

        res.ContactusInfo.map((item) => {
          var obj = {};
          if (item.award2 == 0 || item.award3 == 0) {
            item.type = 1;
          } else {
            item.type = 0;
          }
        });
        this.contacList = res.ContactusInfo;
      } else {
        this.$message({
          message: res.msg,
        });
      }
    });
  },
};
</script>

<style lang="less">
.rules {
  text-align: left;
  .headtitle {
    position: relative;
    font-size: 26px;
    font-family: PingFang SC-Regular, PingFang SC;
    color: #333333;
    font-weight: 500;
    padding-left: 20px;
    margin-left: 5px;
    margin-top: 6px;
    margin-bottom: 25px;
    &:before {
      position: absolute;
      content: "";
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 4px;
      height: 24px;
      background: #6f73f4;
      border-radius: 2px 2px 2px 2px;
    }
  }
  // .boxs {
  //   font-size: 22px;
  //   font-family: PingFang SC-Regular, PingFang SC;
  //   font-weight: 400;
  //   color: #333333;
  //   line-height: 50px;
  //   margin-bottom: 60px;
  // }
}
</style>